module.exports = __webpack_public_path__ + "static/Chaitali-25d86a0e0b5befe7b3fec77eb94e5301.jpg";